import {
  FEISHU_BITABLE_COLLECTION_TYPE,
  FEISHU_BITABLE_CONNECTION_TYPE,
  FEISHU_BITABLE_EXPENSE_COLLECTION_TYPE,
  FEISHU_BITABLE_GROSS_MARGIN_COLLECTION_TYPE,
  FEISHU_BITABLE_SALARY_COLLECTION_TYPE,
  FEISHU_BITABLE_STORE_COLLECTION_TYPE,
  FEISHU_CONTACT_COLLECTION_TYPE,
  FEISHU_CONTACT_CONNECTION_TYPE,
  HOSE_CONNECTION_TYPE,
  HOSE_EXPENSE_COLLECTION_TYPE,
  HOSE_LOAN_COLLECTION_TYPE,
  HOSE_PAYMENT_COLLECTION_TYPE,
  HOSE_REQUISITION_COLLECTION_TYPE,
} from '../services/collect';

const COLLECTION_AGENT_DEFINITIONS = [
  {
    collectionType: FEISHU_BITABLE_COLLECTION_TYPE,
    connectionLabel: '飞书连接',
    connectionType: FEISHU_BITABLE_CONNECTION_TYPE,
    platformLabel: '飞书',
  },
  {
    collectionType: FEISHU_BITABLE_EXPENSE_COLLECTION_TYPE,
    connectionLabel: '飞书连接',
    connectionType: FEISHU_BITABLE_CONNECTION_TYPE,
    eventDomain: 'expense',
    platformLabel: '飞书',
  },
  {
    collectionType: FEISHU_BITABLE_GROSS_MARGIN_COLLECTION_TYPE,
    connectionLabel: '飞书连接',
    connectionType: FEISHU_BITABLE_CONNECTION_TYPE,
    dateMappingMode: 'gross-margin-period',
    eventDomain: 'income',
    platformLabel: '飞书',
  },
  {
    collectionType: FEISHU_BITABLE_STORE_COLLECTION_TYPE,
    connectionLabel: '飞书连接',
    connectionType: FEISHU_BITABLE_CONNECTION_TYPE,
    platformLabel: '飞书',
  },
  {
    collectionType: FEISHU_BITABLE_SALARY_COLLECTION_TYPE,
    connectionLabel: '飞书连接',
    connectionType: FEISHU_BITABLE_CONNECTION_TYPE,
    eventDomain: 'salary',
    platformLabel: '飞书',
  },
  {
    collectionType: FEISHU_CONTACT_COLLECTION_TYPE,
    connectionLabel: '飞书通讯录连接',
    connectionType: FEISHU_CONTACT_CONNECTION_TYPE,
    platformLabel: '飞书通讯录',
  },
  {
    collectionType: HOSE_EXPENSE_COLLECTION_TYPE,
    connectionLabel: '合思连接',
    connectionType: HOSE_CONNECTION_TYPE,
    platformLabel: '合思',
  },
  {
    collectionType: HOSE_LOAN_COLLECTION_TYPE,
    connectionLabel: '合思连接',
    connectionType: HOSE_CONNECTION_TYPE,
    platformLabel: '合思',
  },
  {
    collectionType: HOSE_PAYMENT_COLLECTION_TYPE,
    connectionLabel: '合思连接',
    connectionType: HOSE_CONNECTION_TYPE,
    platformLabel: '合思',
  },
  {
    collectionType: HOSE_REQUISITION_COLLECTION_TYPE,
    connectionLabel: '合思连接',
    connectionType: HOSE_CONNECTION_TYPE,
    platformLabel: '合思',
  },
];

const getCollectionAgentDefinition = (configuration) => {
  const definition = COLLECTION_AGENT_DEFINITIONS.find(
    ({ collectionType, connectionType }) =>
      configuration?.type === 'collection' &&
      configuration.collectionType === collectionType &&
      configuration.connectionType === connectionType,
  );
  if (!definition) {
    throw new Error('不支持的采集 Agent 配置');
  }
  return definition;
};

export { getCollectionAgentDefinition };
